import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { Grid, Divider, TextField, Typography, Button } from "@mui/material";
import { withSnackbar } from "notistack";

import Loader from "../components/common/Loader";
import DraftEditor from "../components/editor";
import ReportActions from "../components/features/report-actions";
 import AudioRecorderPlayer from "../components/features/audio-recorder-player";
import { useAuthUser } from "../store/AuthUserContextProvider";

import {
  getPreviouseStudies,
  getUsersByRole,
  updateStudy,
  writeProcedurePipedData,
  getUsersByUserName,
  getPatientByIdNum,
  resendBilling,
} from "./../api/api";
import ListAlt from "@mui/icons-material/ListAlt";
import ViewScannedDocsModal from "../components/features/modals/view-scanned-docs-modal";
import AudioRecorder from "../components/features/audio-recorder";
import AudioPlayer from "../components/features/audio-player";
const Report = (props) => {
  const { authUser } = useAuthUser();
  const IS_REF_DOC = authUser.Role === "ref-doctor";
  const isDone = props.procedure.data.Status == "DONE" ? true : false
  const [pageRemoteData, setPageRemoteData] = useState({
    radiologists: [],
    previousStudies: [],
  });
  const [loading, setLoading] = useState(false);
  const [study, setStudy] = useState({
    ...props.procedure.data,
    Note: props.procedure.data
      ? props.procedure.data.Note
      : "Type note here ...",
    Recordings: props.procedure.data.Recordings
      ? props.procedure.data.Recordings
      : [],
  });
   
  console.log("props_NOW",props.procedure.data);
  const [audioFileList, setAudioFileList] = useState(props.procedure.data.Recordings ? props.procedure.data.Recordings :[]);
  const [audioBlob, setAudioBlob] = useState(null);
  const writeReport = useRef(props.procedure.data.Note ? props.procedure.data.Note :
   "Type note here ...")
  const handleAddAudioFileToList = (file) => {
    let currentFiles = audioFileList ? audioFileList:[]
    currentFiles.push(file)
    console.log("currentFiles",currentFiles);
    setAudioFileList([...audioFileList, file]);
  };

  const handleRemoveAudioFileFromList = (id) => {
    setAudioFileList(audioFileList.filter((file) => file.id !== id));
  };



 
  useEffect(() => {
    const getPageRemoteData = async () => {
      const [patient, err] = await getPatientByIdNum(study.IDNumber);
      if (err){
        console.log("error while getting patient",err);
      }
      console.log(study.SessionID);
      console.log("YEEA", patient);
      let stringPatient = JSON.stringify(patient.data);
      localStorage.setItem("reportPatient", stringPatient);
      setLoading(true);
      const [radiologists_res, previous_studies_res] = await Promise.all([
        getUsersByRole("radiologist"),
        getPreviouseStudies(study.IDNumber),
      ]);

      const [radiologists, radiologists_err] = radiologists_res;
      const [studies, studies_err] = previous_studies_res;
      let payload = {};

      if (radiologists) {
        payload = {
          ...payload,
          radiologists: radiologists.data,
        };
      } else {
        setLoading(false);
        props.enqueueSnackbar(`Error : ${radiologists_err.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
        return;
      }

      if (studies) {
        payload = {
          ...payload,
          previousStudies: studies.data,
        };
      } else {
        setLoading(false);
        props.enqueueSnackbar(`Error : ${studies_err.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
        return;
      }
      setPageRemoteData(payload);
      setLoading(false);
    };

    getPageRemoteData();

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    document.title = "Report";
  }, []);

  const handleUpdateStudyProperty = (event) => {
    setStudy({
      ...study,
      [event.target.name]: event.target.value,
    });
  };

  const save = async (status) => {
    if (!status) {
      props.close();
    } else {
      setLoading(true);
      // attemp to upload recording first before saving study. this will enforce
      // saving a study that has a recording that was uploaded successfully. If we
      // save study and uploading the recording fails we will have a study that
      // contains a file or a recording that does not exist in s3 hence get a 404
      // when attempting to get the recording.
      study.Note = writeReport.current
      let updatedStudy = { ...study };

      // if (audioFileList.length) {
      //   const [returnUrls, err] = await uploadAudioFilesToS3();
      //   if (err) {
      //     setLoading(false);
      //     return;
      //   } else {
      //     updatedStudy = {
      //       ...updatedStudy,
      //       Recordings: [ ...updatedStudy.Recordings,returnUrls],
      //     };
      //   }
      // }
      const audio = localStorage.getItem("usersAudio")
      if(audio){
      console.log("audio",audio);
        updatedStudy.Recording = audio;
        localStorage.removeItem("usersAudio")
      }
      updatedStudy.Status = status;

      let worklist = [...props.worklist];
      worklist[props.procedure.index] = updatedStudy;

      const [_, err] = await updateStudy(updatedStudy);

      if (!err) {
        props.updateWorklist(worklist);
        props.enqueueSnackbar("Study successfully updated.", {
          preventDuplicate: true,
          variant: "success",
        });
        props.close();
      } else {
        setLoading(false);
        console.error(err.message);
        props.enqueueSnackbar("Error occured when updating a study.", {
          preventDuplicate: true,
          variant: "error",
        });
      }

      //making a call to send the billing report based off the study data

      if ((status === "DONE") & !err) {
        console.log("sending billing report");
        let reportPatient = JSON.parse(localStorage.getItem("reportPatient"));
        console.log("reportPatient", reportPatient);
        const [response, err] = await writeProcedurePipedData(
          updatedStudy,
          reportPatient
        );
        console.log({ response, err });
      } else {
        console.log("cannot send billing reporty because study is not done");
      }
    }
  };




  const updateBillingReport = async () => {
    let updatedStudy = { ...study };
    let reportPatient = JSON.parse(localStorage.getItem("reportPatient"));
    const [response, err] = await resendBilling(
      updatedStudy.Accession,
      updatedStudy,
      reportPatient
    );

    if (err){
      console.error(err.message);
      props.enqueueSnackbar(`Error occured when updating Billing Report :${err}`, {
        preventDuplicate: true,
        variant: "error",
      });
    } else {
      props.enqueueSnackbar("updating Billing Report was successfully", {
        preventDuplicate: true,
        variant: "success",
      })
      props.close();

    }
  };

  const uploadAudioFilesToS3 = async () => {
    const url = `${process.env.REACT_APP_BASE_API_URL}/presignedPutS3url`;
    let returnUrls = [];

    for (let i = 0; i < audioFileList.length; i++) {
      const currentFile = audioFileList[i].file;
      if (currentFile){
      const payload = {
        fileName: currentFile.name,
        fileType: currentFile.type,
      };
    

      try {
        const { data } = await axios.post(url, payload);

        const options = {
          headers: {
            "Content-Type": currentFile.type,
          },
        };

        const returnUrl = data.data.url;
        returnUrls = [...returnUrls, returnUrl];
        const signedUrl = data.data.signedRequest;

        const _ = await axios.put(signedUrl, currentFile, options);
        console.log("SUCCESS");
      } catch (err) {
        props.enqueueSnackbar(err.message, {
          preventDuplicate: true,
          variant: "error",
        });
        console.log(err.message);
        return [null, true];
      }
    }
    }

    props.enqueueSnackbar("Audio(s) successfully uploaded.", {
      preventDuplicate: true,
      variant: "success",
    });

    return [returnUrls, null];
  };

  const handleReportPrint = () => {
    
    localStorage.setItem("current-study-and-report", JSON.stringify(study));
    const reportPrinterTriggerBtn = document.querySelector(
      "#report-printer-trugger-btn"
    );

    if (reportPrinterTriggerBtn) {
      reportPrinterTriggerBtn.click();
    }
  };


  
  return (
    <>
      {!loading && (
        <>
          <Grid container spacing={2} sx={{display:{xs:'none',sm:'flex'}}}>
            <Grid item xs={9}>
              <Typography
                sx={{ marginTop: "15px" }}
                variant="h5"
                component="h2"
              >
                Patient Order Information
              </Typography>
              <Divider sx={{ marginBottom: "15px" }} />
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="name"
                    label="First Name"
                    value={study.FirstName}
                    helperText={"Patients First Name"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="surname"
                    label="Last Name"
                    value={study.LastName}
                    helperText={"Patients Last Name"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    disabled
                    margin="dense"
                    name="sex"
                    label="Sex"
                    value={study.Sex}
                    helperText={"Patients Sex"}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="allergy"
                    label="Allergies"
                    value={"NON"}
                    helperText={"Patients Allergies"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="priority"
                    label="Priority"
                    value={study.Priority}
                    helperText={"Patients Priority"}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="radiographer"
                    label="Radiographer"
                    value={study.AssignedRadiographer}
                    helperText="Radiographer Responsible"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="Accession"
                    label="Accession Number"
                    value={study.Accession}
                    helperText="Patients Accession Number"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="procedure"
                    label="Procedure"
                    value={study.Procedure}
                    helperText="Patients Procedure"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    select
                    fullWidth
                    margin="dense"
                    label="Radiologist"
                    value={study.AssignedRadiologist}
                    helperText="Change Radiologist"
                    onChange={handleUpdateStudyProperty}
                    name="AssignedRadiologist"
                    disabled={isDone || IS_REF_DOC}
                  >
                    <option value={`NONE`}>NONE</option>
                    {pageRemoteData.radiologists.map((radiologist) => (
                      <option
                        key={radiologist.UserName}
                        value={radiologist.UserName}
                      >
                        {radiologist.UserName}
                      </option>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={3}>
              <Typography
                sx={{ marginTop: "15px" }}
                variant="h5"
                component="h2"
              >
                Options
              </Typography>
              <Divider sx={{ marginBottom: "15px" }} />
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled={isDone || IS_REF_DOC}
                    label="ICD"
                    name="ICD"
                    onChange={handleUpdateStudyProperty}
                    margin="dense"
                    value={study.ICD}
                    helperText="Patients ICD"
                  />
                  <TextField
                    disabled
                    fullWidth
                    margin="dense"
                    name="procedure"
                    label="Referrer ICD"
                    value={""}
                    helperText="Patients Referrer ICD"
                  />
                  <TextField
                    disabled
                    fullWidth
                    name="mrn"
                    margin="dense"
                    value={""}
                    label="Procedure ICD"
                    helperText="Patients Procedure ICD"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <ReportActions
                  previousStudiesNeeded={true}
                  studies={pageRemoteData.previousStudies}
                />
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  color="secondary"
                  size="large"
                  startIcon={<ListAlt />}
                  onClick={() => {
                    alert("test");
                  }}
                  sx={{ fontSize: "14px" }}
                >
                  open ICD10 viewer
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  color="secondary"
                  size="large"
                  startIcon={<ListAlt />}
                  href={`http://192.168.50.241:90?accnum=${study.Accession}`}
                  target="_blank"
                  sx={{ fontSize: "14px" }}
                >
                  open image
                </Button>
              </Grid>

              <Grid item xs={3}>
                <ViewScannedDocsModal IDNumber={study.IDNumber} props={props} />
              </Grid>
            </Grid>
          </Grid>

          {!(isDone || IS_REF_DOC) && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  sx={{ marginTop: "15px" }}
                  variant="h5"
                  component="h2"
                >
                  Audio Recording and Playback
                </Typography>
                <Divider sx={{ marginBottom: "15px" }} />
                {/* <AudioRecorderPlayer
                  audioFileList={audioFileList}
                  studyRecordingsList={study.Recordings}
                  handleAddAudioFileToList={handleAddAudioFileToList}
                  handleRemoveAudioFileFromList={handleRemoveAudioFileFromList}
                  Status ={study.Status}
                /> */}
                {/* {study.Status == 'DICTATE' ? (<AudioRecorder initialBase64  ={props.procedure.data.Recording} />): (<AudioPlayer audioSound={props.procedure.data.Recording}/>)} */}
                <AudioRecorder initialBase64  ={props.procedure.data.Recording} />
              </Grid>
            </Grid>
          )}

          <Typography sx={{ marginTop: "15px" }} variant="h5" component="h2">
            Examination Notes
          </Typography>
          <Divider sx={{ marginBottom: "15px" }} />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p style={{ color: "#fff", fontSize: "20px" }}>My Notes</p>
              <TextField
                fullWidth
                multiline
                margin="dense"
                disabled={isDone || IS_REF_DOC}
                rows={4}
                maxRows={10}
                value={study.SideNote}
                name="SideNote"
                onChange={handleUpdateStudyProperty}
                helperText="Add Personal Notes"
                sx={{ mt: "-1px" }}
              />
            </Grid>
          </Grid>
          <Grid>
            <Grid item xs={12}>
              <p style={{ color: "#fff", fontSize: "20px" }}>Submision Notes</p>
              <DraftEditor
                note={writeReport.current}
                isDone={isDone}
                handleReportPrint={handleReportPrint}
                // notes here
                handleNoteChange={(val) => {
                  // setStudy({
                  //   ...study,
                  //   Note: val,
                  // });
                  writeReport.current = val
                }}
              />
            </Grid>
          </Grid>
          <Divider style={{ marginBottom: 30, marginTop: 40 }} />
          <ReportActions
            save={save}
            cancelNeeded={true}
            previousStudiesNeeded={false}
            close={props.close}
            status={study.Status}
            isDone={isDone}
            IS_REF_DOC={IS_REF_DOC}
            studies={pageRemoteData.previousStudies}
            updateBillingReport={updateBillingReport}
          />
        </>
      )}
      {loading && <Loader loading={loading} />}
      <a
        href="/report-printer"
        target="_blank"
        id="report-printer-trugger-btn"
      />
    </>
  );
};

export default withSnackbar(Report);
